import InvestmentOrWithdrawalPlansContainer from './Container';

export default InvestmentOrWithdrawalPlansContainer;